import { Helmet } from 'react-helmet-async';
import { type Manifest } from 'vite';
import { createAssetUrl } from '@/util/asset';
import { getEnv } from "@/util/env.ts";

const {
    PUBLIC_ASSETS_HOST,
    PUBLIC_B2C_ASSETS_HOST,
    PUBLIC_RESIZED_ASSETS_HOST,
    PUBLIC_API_HOST_ORIGIN,
} = getEnv();

const icon = createAssetUrl('favicon.svg');

export type Entries = {
    js: string[];
    css: string[];
};

const createEntries = () => {
    return {
        js: [] as string[],
        css: [] as string[],
    } as Entries;
};

export const manifestToEntries = (manifest: null | Manifest) => {
    const entries = createEntries();

    const indexHtml = manifest?.['index.html'];
    if (indexHtml && indexHtml.file) {
        entries.js.push(createAssetUrl(indexHtml.file));
    }

    if (indexHtml && indexHtml.css) {
        entries.css.push(...indexHtml.css.map(createAssetUrl));
    }

    return entries;
};

const domToEntries = () => {
    try {
        const script = document.getElementById('manifest-data')!;
        const json = JSON.parse(script.textContent);
        if (json) {
            return json as Entries;
        }
    } catch (error) {
        console.error(error);
    }

    return createEntries();
};

export const HeadTags = () => {
    // const services = useServices();
    // const entries = services.entries;

    // const manifestTag = useMemo(() => {
    //     const json = JSON.stringify(entries);

    //     // React compatibility, innerHTML is not used in Preact, but helmet requires it
    //     // https://github.com/staylor/react-helmet-async/blob/23a15037d90ab26a5ad5680d4cf194698bbbf0a1/src/client.js#L18
    //     // https://github.com/staylor/react-helmet-async/issues/59
    //     return createElement('script', {
    //         id: 'manifest-data',
    //         type: 'application/json',
    //         innerHTML: json,
    //     });
    // }, [entries]);

    return (
        <Helmet>
            <link rel="icon" type="image/svg+xml" href={icon} />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <link rel="preconnect" href={PUBLIC_ASSETS_HOST} crossorigin="anonymous" />
            <link rel="preconnect" href={PUBLIC_B2C_ASSETS_HOST} crossorigin="anonymous" />
            <link rel="preconnect" href={PUBLIC_RESIZED_ASSETS_HOST} />
            <link rel="preconnect" href={PUBLIC_API_HOST_ORIGIN} crossorigin="anonymous" />
            {/* {entries.css.map((href) => (
                <link key={href} rel="stylesheet" href={href} />
            ))}
            {entries.js.map((src) => (
                <script key={src} type="module" crossorigin="anonymous" src={src} defer></script>
            ))}
            {manifestTag} */}
        </Helmet>
    );
};
